'use client';

import { useEffect } from 'react';

interface ErrorProp extends Error {
  digest?: string;
}

export function CacheError({ error, reset }: { error: ErrorProp; reset: () => void }) {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_NODE_ENV === 'development') return;

    window.location.reload();
  }, [error]);

  return (
    <div className="card m-auto w-fit max-w-5xl">
      <div className="card-body">
        <h2 className="card-title">Please reload a page</h2>
        <p>
          The cached data is outdated. Please reload the page to maintain smooth and consistent
          experience.
        </p>
        <div className="flex items-center gap-3">
          <button className="btn" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      </div>
    </div>
  );
}
